// components/error/ErrorBoundary.jsx — render zamanı komponent çökərsə ağ ekran
// əvəzinə stilizə olunmuş 500 səhifəsi göstərir.
import React from 'react'
import ErrorPage from './ErrorPage'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, info) {
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.error('ErrorBoundary caught:', error, info)
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className='min-h-screen bg-slate-50'>
                    <ErrorPage code={500} />
                </div>
            )
        }
        return this.props.children
    }
}

export default ErrorBoundary
